/**
 * 404 Not Found Page
 * 
 * Displayed when user navigates to an unknown route.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

function NotFoundPage() {
    return (
        <div className="min-h-screen bg-charcoal flex items-center justify-center px-4 relative overflow-hidden">
            {/* Ambient Background Glows */}
            <div className="absolute -top-48 -right-48 w-96 h-96 bg-wine-700/15 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute -bottom-48 -left-48 w-96 h-96 bg-[#C4A35A]/8 rounded-full blur-3xl pointer-events-none" />

            <div className="text-center max-w-lg relative z-10">
                {/* 404 Number - Fantasy Style */}
                <div className="font-fantasy text-[150px] md:text-[200px] font-bold text-transparent bg-clip-text bg-gradient-to-b from-wine-400/30 to-wine-900/10 leading-none select-none tracking-wider">
                    404
                </div>

                {/* Message */}
                <h1 className="font-fantasy text-3xl md:text-4xl font-semibold text-cream/95 mb-4 -mt-8 md:-mt-12 tracking-wide">
                    Page Not Found
                </h1>

                {/* Gold Ornate Divider */}
                <div className="ornate-divider w-32 mx-auto mb-6" />

                <p className="text-cream/60 text-lg mb-8 font-light">
                    The page you're looking for doesn't exist or has been moved.
                </p>

                {/* Actions - Fantasy Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/"
                        className="btn-fantasy inline-flex items-center justify-center gap-2 px-6 py-3"
                    >
                        <Home className="w-5 h-5" aria-hidden="true" />
                        Go Home
                    </Link>
                    <Link
                        to="/browse"
                        className="inline-flex items-center justify-center gap-2 border border-[#C4A35A]/40 text-[#C4A35A] hover:bg-[#C4A35A]/10 px-6 py-3 rounded-lg transition-colors font-medium tracking-wide"
                    >
                        <Search className="w-5 h-5" aria-hidden="true" />
                        Browse Library
                    </Link>
                </div>

                {/* Back Button */}
                <button
                    onClick={() => window.history.back()}
                    className="mt-8 inline-flex items-center gap-2 text-cream/40 hover:text-[#C4A35A] transition-colors"
                >
                    <ArrowLeft className="w-4 h-4" aria-hidden="true" />
                    Go Back
                </button>
            </div>
        </div>
    );
}

export default NotFoundPage;
